import { matchRoutes, useLocation } from 'react-router-dom';
import { routes } from 'consts';

export const useMatchCurrentLocationRoutes = () => {
    const location = useLocation();
    const matches = matchRoutes(routes, location);

    return matches;
};
